import React, { useMemo, useEffect } from "react";
import { useQuery } from 'react-query'
import { useViewport } from 'components/general/useViewPort'
import { getResultsRSC } from "data/Querys"
import { getLongPhaseRSC, getUnitRSC } from 'helpers/rsc'
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import NotAvailable from 'components/common/NotAvailable';
import Loader from 'components/general/Loader';
import { isStartListStatus, isLiveStatus } from "helpers/status";
import ProgressionRule from "components/common/ProgressionRule";
import PageHeader from "components/common/PageHeader";
import Current from 'components/sports/csl/events/extreme/Current';
import { TableExpanded } from 'components/sports/csl/events/extreme/TableExpanded';
import {
  TableColumnsQUALStartList as ColumnsStartList
  , TableColumnsQUALStartListSM as ColumnsStartListSM
  , TableColumnsQUALLive as ColumnsLive
  , TableColumnsQUALLiveSM as ColumnsLiveSM
  , TableColumnsQUALFinish as ColumnsFinish
  , TableColumnsQUALFinishSM as ColumnsFinishSM
} from 'components/sports/csl/events/extreme/Columns';
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const getConfiguration = (data, breakPoint) => {
  const columnsAdded = [];
  const resultStatus = data?.results?.status?.code;
  const scheduleStatus = data?.results?.schedule?.status?.code;
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")

  let configuration = {
    caption: null,
    columns: [],
    //subComponent: null,
    hiddenColumns: [],
    sortBy: [],
    filters: {
      ei_type: ['NONE'],
      ei_code: ['NONE']
    },
    configs: {
      isStartList: isStartListStatus(resultStatus),
      columnsAdded: columnsAdded,
      previousCurrent: false,
    }
  };

  configuration.caption = <CaptionTable
    leftCol={<Label data={isStartListStatus(resultStatus) ? "HeaderStartList" : "HeaderResults"} />}
    rightCol={<Status typeToPrint='result' scheduleStatus={scheduleStatus} resultStatus={resultStatus} />} />

  configuration.sortBy = isStartListStatus(resultStatus)
    ? [{ id: 'StartOrder', desc: false }]
    : [{ id: 'RankNoType', desc: false }]


  configuration.columns = isMobile
    ? isStartListStatus(resultStatus)
      ? ColumnsStartListSM()
      : isLiveStatus(resultStatus)
        ? ColumnsLiveSM()
        : ColumnsFinishSM()
    : isStartListStatus(resultStatus)
      ? ColumnsStartList()
      : isLiveStatus(resultStatus)
        ? ColumnsLive()
        : ColumnsFinish()

  return configuration;
};

function CslExtremeQualification() {
  const { breakPoint } = useViewport();
  const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()
  let _longPhase = getLongPhaseRSC(mirs_rsc);
  let _unit = getUnitRSC(mirs_rsc)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  //DATA
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsData', mirs_competition, _unit, mirs_language, _longPhase],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    }
  );

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }

  return (
    <ResultPage data={data} breakPoint={breakPoint} />
  );
}

export default CslExtremeQualification;

function ResultPage({ data, breakPoint }) {
  const rsc = data?.results?.eventUnitCode;
  const resultStatus = data?.results?.status?.code;

  const configEvent = useMemo(() => getConfiguration(data, breakPoint), [resultStatus, breakPoint]);

  // Create a function that will render our row sub components
  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <TableExpanded row={row?.original} config={data?.config} resultStatus={resultStatus} />
    }
    />
    // eslint-disable-next-line
  ), [resultStatus, breakPoint]);

  let hiddenColumns = []

  return (
    <>
      <PageHeader data={data} />
      {isLiveStatus(resultStatus) && <Current data={data} />}
      <ProgressionRule key="progress-component" data={data?.config} filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }} />
      {data?.results?.items
        ? (
          <>
            < MirsTable
              //Dato to show by row
              data={data.results.items}
              //Columnas a visualizar 
              columns={configEvent.columns}
              //subcomponente a renderizar, extended
              renderRowSubComponent={renderRowSubComponent}
              //Key by row necesary in order to no paint innecesary
              keyRow='participant-code'
              //Component caption
              caption={configEvent.caption}
              //Columns to hidde 
              hiddenColumns={hiddenColumns}
              //When show tble is sorted by 
              initialSortBy={configEvent.sortBy}
              id={`mirs-table-result-${rsc}`}
            />
          </>
        ) : (
          ''
        )
      }
    </>
  );
}

